import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

/**
 * ComposedStepper
 *
 * Componente para mostrar un stepper horizontal con pasos personalizados.
 *
 * @component
 * @param {Array<string>} stepsData - Lista de nombres de los pasos
 * @param {number} step - Índice del paso actual
 * @returns {JSX.Element}
 */
export const ComposedStepper = ({ stepsData, step }) => {
  const [availableSteps, setAvailableSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (!stepsData) return;
    setAvailableSteps(stepsData);
  }, [stepsData]);

  useEffect(() => {
    if (!step) return;
    setCurrentStep(step);
  }, [step]);

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={currentStep} alternativeLabel>
        {availableSteps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};
